import { useState } from "react";

export default function Inputer({
  id,
  label,
  type,
  placeholder,
  value,
  setValue,
  className,
  multiLine,
}) {
  const [focus, setFocus] = useState(false);
  const handleOnBlur = () => {
    setFocus(false);
  };

  const handleOnFocus = () => {
    setFocus(true);
  };

  const handleOnChange = (e) => {
    if (type === "number") {
      const enValue = +e.target.value;
      const _test = /^[\d.]+$/.test(enValue);
      if (_test) {
        setValue(id, e.target.value, e.target.value !== "" ? true : false);
      }
    } else {
      setValue(id, e.target.value, e.target.value !== "" ? true : false);
    }
  };

  return (
    <div className={`inputer ${focus ? "active" : ""}`}>
      {label && <label htmlFor={id}>{label}</label>}
      {multiLine ? (
        <textarea
          id={id}
          name={id}
          onChange={handleOnChange}
          onFocus={handleOnFocus}
          onBlur={handleOnBlur}
          className={className}
          value={value}
          placeholder={placeholder}
        />
      ) : (
        <input
          id={id}
          name={id}
          type={type !== "number" ? type : ""}
          placeholder={placeholder}
          value={value}
          onChange={handleOnChange}
          onFocus={handleOnFocus}
          onBlur={handleOnBlur}
          className={className}
        />
      )}
    </div>
  );
}
